import axios from '@/api/config';
const campus = {
    getPermissionSubjectTree (data) {
        return axios.get(`${process.env.BASE_URL}/subjectCourse/getSubjectCourseTreeByPermission`, {
            params: data
        });
    },
    // 教材详情
    getTextBook (data) {
        return axios.get(`${process.env.BASE_URL}/textBook/getTextBook`, {
            params: data
        });
    },
    // 教材分页列表查询
    textBookPageList (data) {
        return axios.post(`${process.env.BASE_URL}/textBook/pageList`, data);
    },
    // 新增教材
    addTextBook (data) {
        return axios.post(`${process.env.BASE_URL}/textBook/addTextBook`, data);
    },
    // 修改教材
    updateTextBook (data) {
        return axios.put(`${process.env.BASE_URL}/textBook/updateTextBook`, data);
    },
    // 教材批量删除
    deleteTextBook (data) {
        return axios.post(`${process.env.BASE_URL}/textBook/deleteTextBook`, data);
    },
    // 查询教材对应的渠道商
    agentPageList (data) {
        return axios.post(`${process.env.BASE_URL}/textBookItemAgent/pageList`, data);
    },
    // 批量修改教材渠道商发放数量 put
    updateTextBookItemAgent (data) {
        return axios.put(`${process.env.BASE_URL}/textBookItemAgent/updateTextBookItemAgent`, data);
    },
    // 批量删除教材渠道商
    deleteTextBookItemAgent (data) {
        return axios.post(`${process.env.BASE_URL}/textBookItemAgent/deleteTextBookItemAgent`, data);
    },
    // 查询教材报名的学员
    studentPageList (data) {
        return axios.post(`${process.env.BASE_URL}/textBookStudentApply/pageList`, data);
    },
    // 批量新增教材的渠道商
    addTextBookItemAgent (data) {
        return axios.post(`${process.env.BASE_URL}/textBookItemAgent/addTextBookItemAgent`, data);
    },
    // 商品列表
    pageList (data) {
        return axios.post(`${process.env.BASE_URL}/goodsInfoCenter/pageListByTextBook`, data);
    },
}
export default campus


// WEBPACK FOOTER //
// ./src/api/campus.js